module.exports = __webpack_public_path__ + "img/maki.25766a2f.png";